import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import journeysAPI from '../../api/journeysAPI'
import Layout from '../../components/Layout'
import Header from '../../components/shared/Header'
import Modal from '../../components/shared/Modal'
import './PickingTypes.scss'
import { loadingActions, filterActions } from '../../redux/actions'
import AnotherSessionModal from '../../components/shared/AnotherSessionModal'
import { sessionError } from '../../utils/sessionError'

// const data = [
//   {
//     id: 1,
//     work: 'S',
//     type: 'Delivery'
//   },
//   {
//     id: 2,
//     work: 'SE',
//     type: '90 minutos'
//   }
// ]

const PickingTypes = () => {
  const [types, setTypes] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [modalError, setModalError] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalSession, setModalSession] = useState(false)
  const [selectedType, setSelectedType] = useState(null);
  const dispatch = useDispatch();

  const fetchTypes = async () => {
    try {
      dispatch(loadingActions.setLoading(true));
      const data = await journeysAPI.getJourneys();
      console.log(data);
      setTypes(formatData(data));
      dispatch(loadingActions.setLoading(false));
    } catch (e) {
      dispatch(loadingActions.setLoading(false));
      if (sessionError(e)) {
        setModalSession(true)
      } else {
        setModalError(true);
      }
    }
  };

  const formatData = (data) => {
    return data.map((d) => ({
      id: d.code,
      work: d.code,
      type: d.name,
      pname: d.pname,
    }));
  };

  useEffect(() => {
    fetchTypes();
    // CLEAN FILTERS FROM ALL OTHER TABS
    dispatch(filterActions.cleanAll());
    // eslint-disable-next-line
  }, []);

  const updateItem = async (item) => {
    if (item.dispatchPname.trim() === "") {
      item.dispatchPname = item.dispatchType;
    }
    try {
      dispatch(loadingActions.setLoading(true));
      // await journeysAPI.updateJourneys(
      //   selectedType.id,
      //   item.dispatchWork,
      //   item.dispatchType
      // );
      await journeysAPI.updateJourneys(
        selectedType.id,
        item.dispatchWork,
        item.dispatchType,
        item.dispatchPname
      );
      const tempTypes = [...types];
      const itemIndex = types.findIndex((item) => item.id === selectedType.id);
      tempTypes[itemIndex] = {
        id: item.dispatchWork,
        work: item.dispatchWork,
        type: item.dispatchType,
        pname: item.dispatchPname,
      };
      setTypes(tempTypes);
      dispatch(loadingActions.setLoading(false));
      setShowModal(false);
      setSelectedType(null);
    } catch (e) {
      dispatch(loadingActions.setLoading(false));
      if (sessionError(e)) {
        setModalSession(true)
      }
    }
  };

  const addItem = async (item) => {
    if (item.dispatchPname.trim() === "") {
      item.dispatchPname = item.dispatchType;
    }

    try {
      dispatch(loadingActions.setLoading(true));
      // await journeysAPI.createJourney(item.dispatchWork, item.dispatchType);
      await journeysAPI.createJourney(
        item.dispatchWork,
        item.dispatchType,
        item.dispatchPname
      );
      setTypes([
        ...types,
        {
          id: item.dispatchWork,
          work: item.dispatchWork,
          type: item.dispatchType,
          pname: item.dispatchPname,
        },
      ]);
      dispatch(loadingActions.setLoading(false));
      setShowModal(false);
      setSelectedType(null);
    } catch (e) {
      dispatch(loadingActions.setLoading(false));
      if (sessionError(e)) {
        setModalSession(true)
      } 
    }
  };

  const deleteItem = async () => {
    try {
      dispatch(loadingActions.setLoading(true));
      await journeysAPI.deleteJourney(selectedType.id);
      const filteredData = types.filter((type) => type.id !== selectedType.id);
      setTypes(filteredData);
      dispatch(loadingActions.setLoading(false));
      setModalDelete(false);
      setSelectedType(null);
    } catch (e) {
      dispatch(loadingActions.setLoading(false));
      if (sessionError(e)) {
        setModalSession(true)
      } 
    }
  };

  const renderData = () => {
    return types.map((item) => (
      <div key={item.id} className="company-item">
        <div className="company-info">
          <h2>
            {item.work} - {item.type}
          </h2>
        </div>
        {item.type !== item.pname ? (
          <div className="company-pname">
            <h2>{item.pname}</h2>
          </div>
        ) : null}
        <div className="company-buttons">
          <div
            onClick={() => {
              setSelectedType(item);
              setShowModal(true);
            }}
          >
            <img src={require("../../../assets/icons/edit.svg")} alt="editar" />
          </div>
          <div
            onClick={() => {
              setSelectedType(item);
              setModalDelete(true);
            }}
          >
            <img
              src={require("../../../assets/icons/delete.svg")}
              alt="borrar"
            />
          </div>
        </div>
      </div>
    ));
  };

  return (
    <Layout>
      <AnotherSessionModal isOpen={modalSession} onClose={() => setModalSession(false)} />
      {showModal && (
        <Modal
          visible={showModal}
          onClose={() => setShowModal(false)}
          selectedType={selectedType}
          title={
            selectedType
              ? "Editar despacho existente"
              : "Agregar nuevo tipo de despacho"
          }
          fields={["dispatchWork", "dispatchType", "dispatchPname"]}
          btn1={{
            text: "Cancelar",
            type: "secondary",
            onClick: () => {
              setShowModal(false);
              setSelectedType(null);
            },
          }}
          btn2={{
            text: "Aceptar",
            type: "primary",
            onClick: (data) => {
              selectedType ? updateItem(data) : addItem(data);
            },
          }}
        />
      )}
      {modalDelete && (
        <Modal
          visible={modalDelete}
          onClose={() => setModalDelete(false)}
          title="¿Deseas eliminar este tipo de despacho?"
          color="var(--ripley-salmon)"
          btn1={{
            text: "Cancelar",
            type: "secondary",
            onClick: () => {
              setModalDelete(false);
              setSelectedType(null);
            },
          }}
          btn2={{
            text: "Eliminar",
            type: "primary",
            onClick: () => {
              deleteItem();
            },
          }}
        >
          <div className="modal-delete-company">
            <p>Vas a borrar</p>
            <p className="modal-delete-company-name">{selectedType.type}</p>
            <p className="modal-delete-company-ruc">{selectedType.work}</p>
          </div>
        </Modal>
      )}
      <Modal
        visible={modalError}
        onClose={() => {}}
        title="No hay conexión"
        titleImage={require("../../../assets/icons/ic_disconnected.svg")}
        color="var(--ripley-salmon)"
        btn1={{
          text: "Volver",
          type: "secondary",
          onClick: () => {
            setModalError(false);
          },
        }}
        btn2={{
          text: "Reintentar",
          type: "primary",
          onClick: () => {
            setModalError(false);
            fetchTypes();
          },
        }}
      >
        <div className="modal-error">
          <p>Revisa tu conexión a internet e inténtalo de nuevo</p>
        </div>
      </Modal>
      <div className="picking-types-container">
        <div className="picking-types-container-head">
          <Header
            title="Picking"
            subtitle="Tipos de despachos"
            onClickBtn1={() => setShowModal(true)}
            btnTitle1="Agregar"
          />
        </div>
        <div className="picking-types-container-list">{renderData()}</div>
      </div>
    </Layout>
  );
}

export default PickingTypes
